import i18n from "@/locales";

/**
 * H5 新版开户路由文件
 * */
export default [
    {
        path: "/open-account/landing-page",
        name: "openAccountLandingPage",
        component: () => import("@/views/open-account/landingPage/index.vue"),
        meta: {
            showHeader: false,
            title: i18n.t("openAccount.t000114")
        }
    },
    {
        path: "/open-account/login",
        name: "openAccountLogin",
        component: () => import("@/views/open-account/login/index.vue"),
        meta: {
            showHeader: false,
            title: ''
        }
    },
    {
        path: "/open-account/home",
        name: "openAccountHome",
        component: () => import("@/views/open-account/home/index.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("openAccount.t000121")
        }
    },
    {
        path: "/open-account/customerConfirmation",
        name: "customerConfirmation",
        component: () => import("@/views/open-account/customerConfirmation/customerConfirmation.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("customerConfirmation.c000004")
        }
    },
    {
        path: "/open-account/mainlandInvestorDeclaration",
        name: "mainlandInvestorDeclaration",
        component: () => import("@/views/open-account/mainlandInvestorDeclaration/index.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("mainlandInvestorDeclaration.navTitle")
        }
    },
    {
        path: "/open-account/signaturePage",
        name: "signaturePage",
        component: () => import("@/views/open-account/signaturePage/signaturePage.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("customerConfirmation.c000005")
        }
    },
    {
        path: "/open-account/taxInformation",
        name: "taxInformation",
        component: () => import("@/views/open-account/taxInformation/taxInformation.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("taxInformation.title")
        }
    },
    {
        path: "/open-account/personalInformation",
        name: "personalInformation",
        component: () => import("@/views/open-account/personalInformation/index.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("personalInformation.nav_title")
        }
    },
    {
        path: "/open-account/submitAccount",
        name: "submitAccount",
        component: () => import("@/views/open-account/submitAccount/submitAccount.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("submitAccount.title")
        }
    },
    {
        path: "/open-account/w8benPage",
        name: "w8benPage",
        component: () => import("@/views/open-account/w8benPage/w8benPage.vue"),
        meta: {
            showHeader: true,
            title: 'W-8BEN'
        }
    },
    {
        path: "/open-account/riskDisclosure",
        name: "riskDisclosure",
        component: () => import("@/views/open-account/riskDisclosure/index.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("open_account.risk_disclosure.nav_title")
        }
    },
    {
        path: "/open-account/customerState",
        name: "customerState",
        component: () => import("@/views/open-account/customerState/index.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("customerState.nav_title")
        }
    },
    {
        path: "/open-account/riskQuestionnaire",
        name: "riskQuestionnaire",
        component: () => import("@/views/open-account/riskQuestionnaire/index.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("assessment.question.pageTitle")
        }
    },
    {
        path: "/open-account/suitabilitySurvey",
        name: "suitabilitySurvey",
        component: () => import("@/views/open-account/suitabilitySurvey/suitabilitySurvey.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("suitabilitySurvey.pageTitle")
        }
    },
    {
        path: "/open-account/assessmentResult",
        name: "assessmentResult",
        component: () => import("@/views/open-account/riskQuestionnaire/assessmentResult.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("assessment.result.pageTitle")
        }
    },
    {
        path: "/open-account/serverOpening",
        name: "serverOpening",
        component: () => import("@/views/open-account/serverOpening/index.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("serverOpening.nav_title")
        }
    },
    {
        path: "/open-account/tradingVariety",
        name: "tradingVariety",
        component: () => import("@/views/open-account/tradingVariety/index.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("tradingVariety.nav_title")
        }
    },
    {
        path: "/open-account/open-type",
        name: "OpenType",
        component: () => import("@/views/open-account/openType/index.vue"),
        meta: {
            showHeader: true,
            title: '选择开户方式'
        }
    },
    {
        path: "/open-account/openReference",
        name: "OpenType",
        component: () => import("@/views/open-account/openReference/index.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("open_reference.nav_title")
        }
    },
    {
        path: "/open-account/accountProfile",
        name: "OpenType",
        component: () => import("@/views/open-account/accountProfile/accountProfile.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("accountProfile.a000028")
        }
    },
    {
        path: "/open-account/id-card-upload",
        name: "OpenType",
        component: () => import("@/views/open-account/idCardUpload/index.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("openAccount.t000130")
        }
    },
    {
        path: "/open-account/agreementDeclaration",
        name: "OpenType",
        component: () => import("@/views/open-account/agreementDeclaration/agreementDeclaration.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("agreementDeclaration.a000007")
        }
    },
    {
        path: "/open-account/face-recognition",
        name: "FaceRecognition",
        component: () => import("@/views/open-account/faceRecognition/index.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("openAccount.t000131")
        }
    },
    {
        path: "/open-account/id-card-confirm",
        name: "IdCardConfirm",
        component: () => import("@/views/open-account/idCardConfirm/index.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("openAccount.t000130")
        }
    },
    {
        path: "/open-account/address-prove",
        name: "IdCardConfirm",
        component: () => import("@/views/open-account/addressProve/index.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("openAccount.t000127")
        }
    },
    {
        path: "/open-account/chooseIdentity",
        name: "ChooseIdentity",
        component: () => import("@/views/open-account/ChooseIdentity/index.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("ChooseIdentity.nav_title")
        }
    },
    {
        path: "/open-account/investmentExperience",
        name: "ChooseIdentity",
        component: () => import("@/views/open-account/investmentExperience/index.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("investmentExperience.nav_title")
        }
    },
    {
        path: "/open-account/exemptedCustomers",
        name: "exemptedCustomers",
        component: () => import("@/views/open-account/riskQuestionnaire/exemptedCustomers.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("exemptedCustomers.nav_title")
        }
    },
    {
        path: "/open-account/institutional",
        name: "exemptedCustomers",
        component: () => import("@/views/open-account/institutional/index.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("openAccount.t000020")
        }
    },{
        path: "/open-account/openInstitutionServices",
        name: "openInstitutionServices",
        component: () => import("@/views/open-account/openInstitutionServices/openInstitutionServices.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("openInstitutionServices.p000001")
        }
    },
    {
        path: "/open-account/orgAccResult",
        name: "orgAccResult",
        component: () => import("@/views/open-account/orgAccResult/orgAccResult.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("orgAccResult.g000004")
        }
    },
    // 港美股前置页
    {
        path: "/open-account/stocks-broker",
        name: "stocksBroker",
        component: () => import("@/views/create-account/stocksBroker.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("selectopening.market_hk"),
            deepth: 0
        }
    },
    // 空白前置页
    {
        path: "/open-account/stocks-broker-futures",
        name: "stocksBrokerfutures",
        component: () => import("@/views/create-account/stocksBrokerfutures.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("selectopening.market_glo"),
            deepth: 0
        }
    },

    {
        path: "/open-account/open-add-result",
        name: "openAddResult",
        component: () => import("@/views/open-account/open-add-result/index.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("mki18n.t00033"),
            deepth: 0
        }
    },


]
